import React from 'react';
import './Contact.scss';
function Contact() {
    return (
      <div className="App">
        <div className="contact">
            This is Contact Page
        </div>
      </div>
    );
  }
  
  export default Contact;